require('./protectionWidget.style.scss');

let valueClassesList = ['icon-protected', 'icon-unprotected'],
    valueSubClassesList = ['dr-ready'],
    drReadyColorMap = ['#7530F0', 'rgb(230, 230, 230)'];

class ProtectionWidgetController {
    constructor($element, $scope, $filter, $timeout, styleService, dashboardService, $state) {
        this.$element = $element;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$state = $state;
        this._dashboardService = dashboardService;
        this.donutColors = styleService.getDonutColor('percent');
    }
    $onInit() {
        this.donutSubData = null;
        this.subColors = null;
        this.$scope.$watch(() => this.renderCounter, () => {
            if (!this.items) { return; }
            if (this.drReadySet && this.items.drReadyCount >= 0) {
                this.donutSubData = [this.items.drReadyCount, (this.items.totalCount - this.items.drReadyCount)];
                this.subColors = drReadyColorMap;
            }
            this.donutData = [this.items.protectedCount, this.items.unProtectedCount];
        });
        this.initDonutHighlight();
        this.customText = null;
        this.sortCriteria = '';
    }

    initDonutHighlight() {
        this.$timeout(() => {
            valueClassesList.forEach((item, index) => {
                this.$element.find('details-slot div.' + item + ':not(.dr-ready)').hover(
                    () => {
                        this.$timeout(() => {
                            this.highlightedSlice = index;
                        });
                    },
                    () => {
                        this.$timeout(() => {
                            this.highlightedSlice = undefined;
                        });
                    }
                );
            });
            if (this.drReadySet) {
                valueSubClassesList.forEach((item, index) => {
                    this.$element.find('details-slot div.' + item).hover(
                        () => {
                            this.$timeout(() => {
                                this.subHighlightedSlice = index;
                            });
                        },
                        () => {
                            this.$timeout(() => {
                                this.subHighlightedSlice = undefined;
                            });
                        }
                    );
                });
            }
        });
    }

}

ProtectionWidgetController.$inject = ['$element', '$scope', '$filter', '$timeout', 'styleService', 'dashboardService', '$state'];

const virtualMachinesComponent = {
    controller: ProtectionWidgetController,
    template: require('./protectionWidget.template.html'),
    bindings: {
        widgetName: '@',
        widgetState: '@',
        items: '<',
        renderCounter: '<',
        widgetTitleTooltip: '@?',
        drReadySet: '<?',
        cursorPointer: '<'
    }
};

module.exports = virtualMachinesComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/protectionWidget/protectionWidget.component.js